<template>
  <div :class="['wrapper', classes]">
    <header class="main-header fuente">
      <a href="#" class="fuente logo">
        <span class="logo-mini"><img src="/static/img/hombre.png" width="40" alt="logo"></span>
        <span style="color: #333; letter-spacing: 1px" class="fuente fs-15"><img src="/static/img/favicon.png" width="40"
            alt="logo" class="fuente m-r-10">USUARIOS</span>
      </a>
      <nav class="navbar navbar-static-top" role="navigation">
        <a href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button">
          <span class="sr-only">Toggle navigation</span>
        </a>         
        <div class="navbar-custom-menu">
          <ul class="nav navbar-nav">
            <!--
            <li class="dropdown user user-menu">
              <a  class="dropdown-toggle" data-toggle="dropdown">
                <i class="fas fa-id-card"></i>
                <span style="text-transform: uppercase" class="fuente hidden-xs">DNI: {{dni}}</span>
                <i class="fa fa-user"></i>
                <span style="text-transform: uppercase" class="fuente hidden-xs">NOMBRES: {{nombres}}</span>
                <i class="fa fa-user"></i>
                <span style="text-transform: uppercase" class="fuente hidden-xs">USUARIO: {{displayName}}</span>
              </a>
            </li>
            -->
            <!-- Menú desplegable -->
            <li class="dropdown user user-menu">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                <i class="fa fa-user"></i>
                <span style="text-transform: uppercase" class="fuente hidden-xs"> {{ displayName }} <b
                    class="caret"></b></span>
              </a>
              <ul class="dropdown-menu-custom">
                <li><a href="#"><span class="limited-text">{{ nombres }}</span></a></li>
                <li><a href="#" class="limited-text">DNI: {{ dni }}</a></li>
                <!-- 
                  <li><a href="#"><i class="fa fa-user"></i> DNI: {{dni}}</a></li>
                  <li><a href="#"><i class="fa fa-info-circle"></i> NOMBRES: {{nombres}}</a></li>
                -->
              </ul>
            </li>

            <li class="dropdown user user-menu" @click="cerrarSesion()">
              <a style="cursor:pointer" class="dropdown-toggle" data-toggle="dropdown">
                <i class="fa fa-power-off"></i>
                <span class="fuente hidden-xs">SALIR</span>
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <sidebar></sidebar>
    <div class="content-wrapper">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
    <footer class="main-footer">
      <a class="fuente fs-13" style="color: #333">Desarrollado por la Oficina de Tecnologías de la Información - 2018</a>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import config from '../config'
import Sidebar from './Sidebar'
import 'hideseek'
import App from './App';
import Swal from 'sweetalert2'; //librería para mensajes de alerta, ventanas emergentes
import 'sweetalert2/dist/sweetalert2.min.css';


export default {
  name: 'Dash',
  components: {
    Sidebar
  },
  data: function () {
    return {
      //displayName: this.$session.get('user'), //// se envío el displayName al computed para obtenerlo como un valor dinámico
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: config.fixedLayout,
        hide_logo: config.hideLogoOnMobile
      },
      error: ''
    }
  },

  computed: {
    // Obtener los datos del store
    ...mapState(['dni', 'nombres']),
    displayName() {
      return this.$session.get('user');
    },
        
  },

  beforeCreate: function () {
    if (!this.$session.exists()) {
      this.$router.push('/login')
    }
  },
  methods: {
    changeloading() {
      this.$store.commit('TOGGLE_SEARCHING')
    },
    cerrarSesion: function () {
      
      //Mensaje de alerta para confirmar Salir
      Swal.fire({
        title: '¿Estás seguro de salir?',
        //text: 'Si sales, perderás los cambios no guardados.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, salir',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          // Aquí se realiza la acción Salir, para ello llamar al método logout de app.vue
          App.methods.logout.call(this);
          //this.$session.destroy()
          //localStorage.removeItem('AccessToken')
          //this.$router.push('/login')
        }
      });           
    }
  }
}
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s
}

.fade-enter,
.fade-leave-to {
  opacity: 0
}

.wrapper.fixed_layout {
  .main-header {
    position: fixed;
    width: 100%;
  }

  .content-wrapper {
    padding-top: 50px;
  }

  .main-sidebar {
    position: fixed;
    height: 100vh;
  }
}

.wrapper.hide_logo {
  @media (max-width: 767px) {
    .main-header .logo {
      display: none;
    }
  }
}

.logo-mini,
.logo-lg {
  text-align: left;

  img {
    padding: .4em !important;
  }
}

.logo-lg {
  img {
    display: -webkit-inline-box;
    width: 25%;
  }
}

.user-panel {
  height: 4em;
}

hr.visible-xs-block {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.17);
  height: 1px;
  border-color: transparent;
}

.limited-text {
  max-width: 250px;
  /* Establece el ancho máximo */
  display: inline-block;
  white-space: pre-wrap;
  margin-left: 5px;
}

/*
.detalle-span {
  line-height: 42px;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
}
*/

.dropdown-menu-custom {
  display: none;
  position: absolute;
  background-color: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  /*padding: 10px;*/
  left: 0;
  min-width: 225px;
}

.dropdown:hover .dropdown-menu-custom {
  display: block;
}

 .dropdown-menu-custom li:hover {
    background-color: #f2f2f2;  /* Cambia el color de fondo al pasar el cursor */
  }

  .dropdown-menu-custom a:hover {
    text-decoration: none;  /* Elimina la subraya al pasar el cursor sobre el enlace */
  }

</style>



// WEBPACK FOOTER //
// Dash.vue?57b3400b